import React from 'react'
import PropTypes from 'prop-types'

import PaginationItem from 'Components/Pagination/PaginationItem'
import PaginationRow from 'Components/Pagination/PaginationRow'
import PaginationSummary from 'Components/Pagination/PaginationSummary'

import { buildPaginationArray } from './helpers.js'

const Pagination = ({ itemName, items, page, pages, setPage }) => {
  const pagesArray = buildPaginationArray(page, pages).map((n, i) => {
    if (n === page) {
      return <PaginationItem page={n} key={n} setPage={setPage} active />
    } else {
      return <PaginationItem page={n} key={n} setPage={setPage} />
    }
  })

  return (
    <div>
      {pages > 1 && <PaginationRow page={page} pages={pages} pagesArray={pagesArray} setPage={setPage} />}

      <PaginationSummary itemName={itemName} items={items} pages={pages} />
    </div>
  )
}

Pagination.propTypes = {
  itemName: PropTypes.string.isRequired,
  items: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
}

export default Pagination
